import React from 'react';
import { Route, IndexRoute } from 'react-router';
import App from './containers/App';
/* import NotFoundPage from './containers/NotFoundPage.js'; */
import HomePageNew from './containers/HomePageNew';
//import HomePage from './containers/HomePage';

import Institucional from './containers/Institucional';
import Historia from './containers/Historia';
import Governanca from './containers/Governanca';
import Compliance from './containers/Compliance';
import Transparencia from './containers/Transparencia';
import Idss from './containers/Idss';
import ForYouAndYourFamilyNew from './containers/ForYouAndYourFamilyNew';
import ForYourCompanyNew from './containers/ForYourCompanyNew';
import FormMakeYourPlanNew from './containers/FormMakeYourPlanNew';

import Success from './containers/Success';

import ConfirmProposalPage from './containers/ConfirmProposalPage';
import ConfirmCompanyPage from './containers/ConfirmCompanyPage';
import LittleWalletNew from './containers/LittleWalletNew';
import PrivacyPolicy from './containers/PrivacyPolicyPage';

import SecondPaymentSlip from './containers/SecondPaymentSlipNew';
import AccreditedNetworkNew from './containers/AccreditedNetworkNew';
import ProposalStatusPage from './containers/ProposalStatusPageNew';

import PromotionalMaterialsPage from './containers/Panel/PromotionalMaterialsPage';
import DentalNewspage from './containers/Panel/DentalNewspage';
import Resume from './containers/Panel/ResumePage';

{/* Dashbard*/}
import DashboardAdmin from './containers/Panel/DashboardAdminPage';
{/* */}
import PessoaFisica from './containers/Panel/PessoaFisicaPage';
import PessoaJuridica from './containers/Panel/PessoaJuridicaPage';
import Intranet from './containers/Panel/IntranetPage';

import SelectInclusao from './containers/Panel/SelectInclusao';
import Inclusao from './containers/Panel/InclusaoPage';
import ListInclusion from './containers/Panel/ListInclusion';
import ConfirmInclusion from './containers/ConfirmInclusion';


import ProposalsPage from './containers/Panel/ProposalsPage';
import ProposalsAllPage from './containers/Panel/ProposalsAllPage';
import SalesmansPage from './containers/Panel/SalesmansPage';
import BrokersPage from './containers/Panel/BrokersPage';
import LinkSitePage from './containers/Panel/LinkSitePage';
import ContributorsPage from './containers/Panel/ContributorsPage';
import SalesRegistrationPage from './containers/Panel/SalesRegistrationPage';

import PendenciesPage from './containers/Panel/PendenciesPage';
import CancellationsPage from './containers/Panel/CancellationsPage';
import ImageDocPage from './containers/Panel/ImageDocPage';
import SpinImagePage from './containers/SpinImagePage';
import BackOfficePage from './containers/Panel/BackOfficePage';
import FormsOfReceiptsPage from './containers/Panel/FormsOfReceiptsPage';
import RegisterCompanyPage from './containers/Panel/RegisterCompanyPage';
import CompanyListAllPage from './containers/Panel/CompanyListAllPage';
import CompanyListPage from './containers/Panel/CompanyListPage';

import rede_credenciada from './containers/Panel/RelatorioRedeCredenciada';

import Logout from './containers/Panel/LogoutPage';
import ChooseImageTopSitePage from './containers/Panel/ChooseImageTopSitePage';
import PlanRegistrationPage from './containers/Panel/PlanRegistration';
import PlanListPage from './containers/Panel/PlanListPage';

import BrokerRegistrationPage from './containers/Panel/BrokerRegistration';

// temporario
//import PlanoSaoLuizPage from './containers/PlanoSaoLuiz';
//import PlanoMeiPage from './containers/PlanoMei';
import RecoverPasswordPage from './containers/RecoverPasswordPage';
import ChangePasswordPage from './containers/ChangePasswordPage';
import ResumoProposta from './containers/Panel/ResumoProposta';
import InclusaoAssociadoPage from './containers/Panel/InclusaoAssociadoPage';
import VendasPorVendedorPage from './containers/Panel/VendasPorVendedorPage';
import AverbacaoPage from './containers/Panel/AverbacaoPage';

export default (
  <Route>
    <Route path="/" component={App}>
      <IndexRoute component={HomePageNew}/>
      <Route path="home" component={HomePageNew}/>

      <Route path="institucional" component={Institucional} />
      <Route path="historia" component={Historia} />
      <Route path="governanca" component={Governanca} />
      <Route path="compliance" component={Compliance} />

      <Route path="transparencia" component={Transparencia} />
      <Route path="idss" component={Idss} />
      <Route path="parasuafamilia" component={ForYouAndYourFamilyNew}/> {/** foryouandyourfamily*/}
      <Route path="parasuaempresa" component={ForYourCompanyNew}/> {/** foryourcompany*/}
      <Route path="formmakeyourplan"  component={FormMakeYourPlanNew}/>
      <Route path="acessar"  component={FormMakeYourPlanNew} />  

      <Route path="sucesso" component={Success} />

      {/* Temporario ou não 
      <Route path="planosaoluis" component={PlanoSaoLuizPage} />
      <Route path="planomei" component={PlanoMeiPage} />
   */}
      {/* <Route path="formmakeyourplan/:plan" component={FormMakeYourPlanNew}/> */}
    
      <Route path="confirme-sua-proposta-de-inclusao(/:filter)" component={ConfirmInclusion} />      
      <Route path="confirmproposal" component={ConfirmProposalPage}/>
      <Route path="confirmcompany" component={ConfirmCompanyPage}/>
      <Route path="institucional" component={LittleWalletNew}/>

      {/* <Route path="wallet" component={LittleWalletNew} />*/}
      <Route path="carteirinha" component={LittleWalletNew} />
      <Route path="privacypolicy" component={PrivacyPolicy}/>
    {/*   <Route path="secondpayment" component={SecondPaymentSlip}/> */}
      <Route path="boletodigital" component={SecondPaymentSlip}/>
     {/* <Route path="accreditednetwork" component={AccreditedNetworkNew}/>*/}
      <Route path="redecredenciada" component={AccreditedNetworkNew}/>

      <Route path="spinimage" component={SpinImagePage}/>
      <Route path="situacaoproposta" component={ProposalStatusPage}/>
      <Route path="assets/pdf/GuiaSucessoDentistaCredenciado.pdf"/>
       {/* DASHBOARD*/}
      <Route path="dashboard/admin" component={DashboardAdmin}/> 
       {/* FIM DASHBOARD*/}
      <Route path="panel" component={Resume}/>
      <Route path="panel/painel-inclusao" component={SelectInclusao} />
      <Route path="panel/inclusao" component={Inclusao} />
      <Route path="panel/lista-de-inclusoes(/:filter)" component={ListInclusion} />      
      <Route path="panel/pessoa-fisica" component={PessoaFisica} />
      <Route path="panel/pessoa-juridica" component={PessoaJuridica} />
      <Route path="panel/intranet" component={Intranet} />
      <Route path="panel/promotionalmaterials" component={PromotionalMaterialsPage}/>
      <Route path="panel/dentalnews" component={DentalNewspage}/>
      <Route path="panel/linksite" component={LinkSitePage}/>
      <Route path="panel/proposals/:table" component={ProposalsPage}/>
      <Route path="panel/proposalsall" component={ProposalsAllPage}/>
      <Route path="panel/logout" component={Logout}/>
      <Route path="panel/rede_credenciada" component={rede_credenciada}/>

      <Route path="panel/chooseimagetopsite" component={ChooseImageTopSitePage}/>
      <Route path="panel/salesmans" component={SalesmansPage}/>
      <Route path="panel/brokers" component={BrokersPage}/>
      <Route path="panel/contributors" component={ContributorsPage}/>
      <Route path="panel/salesregistration(/:cpf)(/:contractid)(/:confirmationtype)" component={SalesRegistrationPage}/>
      <Route path="panel/salesregistrationServidor/:servidor" component={SalesRegistrationPage}/>

      <Route path="resumo_proposta" component={ResumoProposta}/>

      <Route path="panel/pendencies" component={PendenciesPage}/>
      <Route path="panel/cancellations" component={CancellationsPage}/>
      <Route path="panel/imagedoc" component={ImageDocPage}/>
      <Route path="panel/backoffice" component={BackOfficePage}/>
      <Route path="panel/formsofreceipts" component={FormsOfReceiptsPage}/>
      <Route path="panel/registercompany" component={RegisterCompanyPage}/>
      <Route path="panel/inclusaoassociado" component={InclusaoAssociadoPage}/>
      <Route path="panel/vendas-por-vendedor" component={VendasPorVendedorPage}/>

      <Route path="panel/companylist" component={CompanyListAllPage}/>
      <Route path="panel/companylist/:table" component={CompanyListPage}/>
      <Route path="forgot-password" component={RecoverPasswordPage}/>
      <Route path="change-password" component={ChangePasswordPage}/>

      <Route path="panel/planregistration" component={PlanRegistrationPage}/>
      <Route path="panel/planlist" component={PlanListPage}/>

      <Route path="panel/brokerregistration" component={BrokerRegistrationPage}/>
      <Route path="panel/financeiro" component={AverbacaoPage}/>

      <Route path=":linksite" component={ForYouAndYourFamilyNew}/>

      {/* <Route path="*" component={NotFoundPage}/> */}
    </Route>
  </Route>
);



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/